exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.6);\n    z-index: 999;\n}\n\n.modal-main {\n    position: fixed;\n    background: rgba(0, 0, 0, .8);\n    width: 100vw;\n    height: 100vh;\n    top: 0;\n    left: 0;\n}\n\n.modal-main .closeButton {\n    float: right;\n    padding-right: 2%;\n    padding-top: 1%;\n    stroke: aliceblue;\n    cursor: pointer;\n}\n\n.modal-main .closeButton svg {\n    margin: auto;\n}\n\n.display-block {\n    display: block;\n}\n\n.display-none {\n    display: none;\n}", ""]);

// exports
